
























































































































import {
  MErrorResourceUnavailable,
  MLink,
  MMessage,
  MSpinner,
} from "@ulaval/modul-components";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import { Location } from "../models/Location";
import router from "../router";
import store, { modules } from "../store";

@Component({
  components: { MMessage, MLink, MSpinner, MErrorResourceUnavailable },
})
export default class Accueil extends Vue {
  private chargementEnCours: boolean = true;
  private afficherBoutonLouerCasier: boolean = true;

  private enMaintenance: boolean =
    process.env.VUE_APP_EN_MAINTENANCE === "true";

  private messageAuxUtilisateurs: string =
    process.env.VUE_APP_MESSAGE_AUX_UTILISATEURS || "";
  private enApprobation: boolean =
    process.env.VUE_APP_EN_APPROBATION === "true";
  private utilisateurEstAdmin: boolean = false;

  private hints: [string] = [this.messageAuxUtilisateurs];

  private arrIDULAdmin: Array<string> = [
    "jober160@ulaval.ca",
    "nades157@ulaval.ca",
    "fxpaq@ulaval.ca",
    "loemo21@ulaval.ca",
    "mcleg11@ulaval.ca",
    "maber833@ulaval.ca",
    "fados1@ulaval.ca",
    "cstss@ulaval.ca",
  ];

  private columns = [
    { id: "pavillon", title: "Pavillon", dataProp: "pavillon" },
    { id: "niveau", title: "Niveau", dataProp: "niveau" },
    { id: "casier", title: "No. Casier", dataProp: "casier" },
    { id: "debutLocation", title: "Début location", dataProp: "debutLocation" },
    { id: "finLocation", title: "Fin location", dataProp: "finLocation" },
  ];
  private rows = new Array<{
    pavillon: string;
    niveau: string;
    casier: string;
    debut: string;
    fin: string;
  }>();

  protected async mounted(): Promise<void> {
    // Vérification de la présence du compte dans la liste des admins
    let username = this.$msal.data.user?.userName || "";
    if (this.arrIDULAdmin.indexOf(username.toLowerCase()) > -1) {
      // Annulation de l'état "approbation", pour permettre aux admins d'accéder à l'application
      this.utilisateurEstAdmin = true;
    }

    try {
      await store.dispatch(modules.cds.actions.recupererLocations.name, {
        vm: this,
        idUtilisateur: this.$msal.data.query.profile?.id || "",
      });

      this.formatterLocations();
    } catch (e) {
      store.commit(modules.cds.mutations.recupererLocationsEchec.name);

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        store.state.applicatif.messageErreurParDefaut
      );
    }

    // Vérification de la présence d'au moins une période active
    try {
      await store.dispatch(modules.cds.actions.recupererPeriodes.name, {
        typePeriodeId: null,
        vm: this,
      });
    } catch (e) {
      store.commit(modules.cds.mutations.recupererPeriodesEchec.name);
      store.commit(
        modules.utilisateur.mutations.recupererLocationsUtilisateurEchec.name
      );

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        store.state.applicatif.messageErreurParDefaut
      );
    }

    this.chargementEnCours = false;
  }

  private formatterLocations(): void {
    for (const location of this.locations) {
      const debut = moment(location.periode.dateDebut).format("YYYY-MM-DD");
      const fin = moment(location.periode.dateFin).format("YYYY-MM-DD");
      const pavillon = location.pavillon.nomPavillon;
      const niveau = location.niveau.nomNiveau;
      const casier = location.casier.numero;

      this.rows.push({ pavillon, niveau, casier, debut, fin });
    }
  }

  private async debuterProcessusLocationCasier(): Promise<void> {
    store.commit(modules.utilisateur.mutations.effacerStateUtilisateur.name);
    store.commit(
      modules.utilisateur.mutations.initialiserDebutCreationLocation.name
    );
    const route: string = await store.dispatch(
      modules.trainProgression.actions.debuterLocation.name
    );

    router.push({ name: route });
  }

  get locations(): Location[] {
    return store.state.cds.locations;
  }

  get detailsNouvelleLocation(): string {
    const nouvelleLocation = store.state.utilisateur.nouvelleLocation;
    if (nouvelleLocation !== null) {
      const message = `La location du casier ${nouvelleLocation.casier.numero} est confirmée pour la session ${nouvelleLocation.periode.nomPeriode}.`;

      // Une fois le message de succès affiché, on efface le state de l'utilisateur
      store.commit(modules.utilisateur.mutations.effacerStateUtilisateur.name);

      return message;
    } else {
      return "";
    }
  }

  get locationPossible(): boolean {
    const aujourdhuiUTC = new Date();
    const aujourdhui = new Date(
      aujourdhuiUTC.getTime() - aujourdhuiUTC.getTimezoneOffset() * 60000
    );
    aujourdhui.setHours(0, 0, 0, 0);

    const periodesActives = store.state.cds.periodes.filter((periode) => {
      return (
        new Date(Date.parse(periode.dateDebut)) <= aujourdhui &&
        new Date(Date.parse(periode.dateFin)) >= aujourdhui
      );
    });
    return periodesActives.length > 0;
  }
}
